module.exports = __webpack_public_path__ + "c14bf8cebb2f392123a1bce4196158e8.png";